import {KmsTypeComponent} from "@mediaspace/shared/types";
import {ReactElement} from "react";
import {styled} from "@mui/material";
import {Box} from "@mediaspace/shared/styled";

type CtaProps = {
    components: KmsTypeComponent[],
    renderComponent: (component: KmsTypeComponent) => ReactElement,
    className: string,
    noSidebarTopAndLists: boolean
}

const StyledCtaContainer = styled(Box)(({theme}) => ({
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(-2),
    "&:empty": {
        display: "none"
    }
}));

const CtaContainer = (props: CtaProps) => {
    const {components, renderComponent, className, noSidebarTopAndLists} = props;

    const ctaComponents = components.map(component => {
        component.props = {...component.props, isEmptyRightPanel: noSidebarTopAndLists, parent: "sidebar"};
        return renderComponent(component);
    });

    return (
        <StyledCtaContainer className={className}>
            {ctaComponents.map(component => <>{component}</>)}
        </StyledCtaContainer>
    )
}

export default CtaContainer;
